<template>
    <div>
        <p>
            <strong>Conformément aux articles 1341 et 1342 du Code civil italien</strong>, l’Utilisateur déclare expressément avoir lu, compris et
            accepté les clauses suivantes&nbsp;:
        </p>
        <p>Art. 1, Définitions, lettre l), « Fleequid », entité juridique et régime fiscal applicable&nbsp;;</p>
        <p>Art. 2.3 Commissions à la charge du Vendeur et de l’Acheteur&nbsp;;</p>
        <p>Art. 2.4 Modalités des enchères et détermination du prix d’adjudication&nbsp;;</p>
        <p>Art. 2.5 Processus de revente&nbsp;;</p>
        <p>
            Art. 3 Approbation d’éventuelles conditions générales proposées par les utilisateurs, modification unilatérale des Conditions Générales
            par Fleequid et hiérarchie des documents contractuels&nbsp;;
        </p>
        <p>Art. 4.5 Limitations d’utilisation du Marketplace&nbsp;;</p>
        <p>Art. 4.6 Mesures prises par Fleequid en cas de violation des règles d’utilisation&nbsp;;</p>
        <p>Art. 4.7 Résiliation&nbsp;;</p>
        <p>Art. 4.8 Pénalité&nbsp;;</p>
        <p>Art. 4.10 Exonération de responsabilité relative au fonctionnement du Marketplace&nbsp;;</p>
        <p>Art. 4.11 Suppression du profil Utilisateur et exercice du droit de rétractation&nbsp;;</p>
        <p>
            Art. 6 relatif à&nbsp;: clause résolutoire expresse, exclusivité de vente, conditions et durée de ladite exclusivité, possibilité
            d’adjudication ultérieure, limitations de vente, faculté d’annulation ou de résiliation de la vente en cas de retard ou de non-paiement de
            l’Acheteur, renonciation du Vendeur à toute réclamation ou exception, clause de garantie et d’indemnisation, dossier technique, pénalités
            à la charge du Vendeur&nbsp;;
        </p>
        <p>
            Art. 7 Invitation à contracter (invitatio ad offerendum), durée de l’offre irrévocable d’achat, conditions particulières d’enchères, prix
            de réserve&nbsp;;
        </p>
        <p>Art. 8.4 Traitement du dépôt de garantie&nbsp;;</p>
        <p>Art. 9.3 Paiement du prix du véhicule&nbsp;;</p>
        <p>
            Art. 9.4 Facturation anticipée à la demande de Fleequid, condition suspensive du paiement subordonnée à l’encaissement intégral par
            l’Acheteur (pay-when-paid), obligation d’émettre un avoir en cas de non-paiement ou d’annulation de la vente, faculté de compensation,
            pénalités journalières pour retards ou omissions et renonciation du Vendeur à toute réclamation ou exception à l’encontre de
            Fleequid&nbsp;;
        </p>
        <p>Art. 9.5 Pénalité&nbsp;;</p>
        <p>Arts. 9.7 et 9.8 Délais de dénonciation des vices et défauts&nbsp;;</p>
        <p>Art. 9.10 Clause résolutoire expresse et pénalité&nbsp;;</p>
        <p>
            Art. 10 Conditions de paiement, résiliation, pénalités, conditions régissant la revente et exonération de responsabilité, kilométrage,
            délais de vérification des défauts lors de la livraison&nbsp;;
        </p>
        <p>
            Art. 11 Exclusion de garantie et exonération de responsabilité de Fleequid, transfert des risques, clause résolutoire expresse, pénalités,
            droit d’annulation de la vente, exclusion des vices cachés, limites de responsabilité fondées sur le kilométrage et l’âge du
            véhicule&nbsp;;
        </p>
        <p>
            Art. 13 Réclamations, propositions de résolution des réclamations, résolution de la réclamation par Fleequid par annulation de la vente,
            vices cachés, exonération de responsabilité, clause « vendu en l’état », pénalités&nbsp;;
        </p>
        <p>Art. 14 Clause de rattachement&nbsp;;</p>
        <p>Art. 15 Loi applicable, langue et juridiction compétente.</p>
    </div>
</template>
